<template>
  <div>
    <!-- <overall-result /> -->
    <!-- <div class="printBtn">
    
      <v-btn color="primary" fab small dark style="margin-top:48px" @click="downloadWithCSS">
        <v-icon>mdi-printer</v-icon>
      </v-btn>
    </div> -->

    <ResultWrap />
  </div>
</template>

<script>
import ProjectRetvGraph from '@/components/Graphs/Result/ProjectRetvGraph.vue';
import ProjectTermWiseRetv from '@/components/Graphs/Result/ProjectTermWiseRetv.vue';
import ProjectRoofGraph from '@/components/Graphs/Result/ProjectRoofGraph.vue';
import ProjectWallGraph from '@/components/Graphs/Result/ProjectWallGraph.vue';
import ProjectGlassGraph from '@/components/Graphs/Result/ProjectGlassGraph.vue';
import ProjectShgcGraph from '@/components/Graphs/Result/ProjectShgcGraph.vue';
import VueHtml2pdf from 'vue-html2pdf';
import ResultWrap from './ResultWrap.vue';
// import jsPDF from 'jspdf';
// import html2canvas from 'html2canvas';
// import domtoimage from 'dom-to-image';
export default {
  components: {
    ProjectRetvGraph,
    ProjectTermWiseRetv,
    ProjectRoofGraph,
    ProjectWallGraph,
    ProjectGlassGraph,
    ProjectShgcGraph,
    VueHtml2pdf,
    ResultWrap,
  },
  // computed: {
  //   schema: {
  //     get: function() {
  //       return this.$store.state.schema;
  //     },
  //     set: function(newSchema) {
  //       this.$store.dispatch('setSchema', newSchema);
  //     },
  //   },
  //   step3B: {
  //     get: function() {
  //       return this.$store.state.schema.inputs.step3B;
  //     },
  //     set: function(step3B) {
  //       this.$store.dispatch('setStep3B', step3B);
  //     },
  //   },
  //   step4: {
  //     get: function() {
  //       return this.$store.state.schema.inputs.step4;
  //     },
  //     set: function(step4) {
  //       this.$store.dispatch('setStep4', step4);
  //     },
  //   },
  //   step3C: {
  //     get: function() {
  //       return this.$store.state.schema.inputs.step3C;
  //     },
  //     set: function(step3B) {
  //       this.$store.dispatch('setStep3C', step3C);
  //     },
  //   },
  //   step5A: {
  //     get: function() {
  //       return this.$store.state.schema.inputs.step5A;
  //     },
  //     set: function(step5A) {
  //       this.$store.dispatch('setStep5A', step5A);
  //     },
  //   },
  //   retv6B: {
  //     get: function() {
  //       return this.$store.state.schema.inputs.retv6B;
  //     },
  //     set: function(retv6B) {
  //       this.$store.dispatch('setRetv6B', retv6B);
  //     },
  //   },
  //   retv6C: {
  //     get: function() {
  //       return this.$store.state.schema.inputs.retv6C;
  //     },
  //     set: function(retv6C) {
  //       this.$store.dispatch('setRetv6C', retv6C);
  //     },
  //   },
  //   projects: {
  //     get: function() {
  //       // console.log('Wall Index', this.wallIndex);
  //       console.log(this.$store.state.projects);
  //       return this.$store.state.projects;
  //     },
  //     set: function(Project) {
  //       this.$store.dispatch('setProjects', Project);
  //     },
  //   },
  //   glazingSelection() {
  //     const glazingSet = new Set();
  //     this.step3B.windowTypeArrObj[0].orientationObj.forEach(orient => {
  //       if (orient.calcOpenableArea !== 0 && orient.calcOpenableArea !== '') {
  //         if (orient.selectedNonOpaqueMaterial && orient.selectedNonOpaqueMaterial.material) {
  //           glazingSet.add(orient.selectedNonOpaqueMaterial.material);
  //           console.log('glazing', glazingSet);
  //         }
  //       }
  //     });
  //     this.schema.glazingSelectionData = Array.from(glazingSet);
  //     return glazingSet;
  //   },
  //   shadingSelection() {
  //     const shadingSet = new Set();
  //     this.step3B.windowTypeArrObj.forEach(window => {
  //       window.orientationObj.forEach(orient => {
  //         if (orient.calcOpenableArea !== 0 && orient.calcOpenableArea !== '') {
  //           if (orient.selectedShading && orient.selectedShading.title) {
  //             shadingSet.add(orient.selectedShading.title);
  //           }
  //         }
  //       });
  //     });
  //     this.step3C.ventilatorArrObj.forEach(venti => {
  //       if (venti.calcGlassArea !== 0) {
  //         if (venti.selectedShading && venti.selectedShading.title) {
  //           shadingSet.add(venti.selectedShading.title);
  //         }
  //       }
  //     });
  //     this.schema.shadingSelectionData = Array.from(shadingSet);
  //     return shadingSet;
  //   },
  //   wallConstructionAssembly() {
  //     const wallConstructionData = new Set();
  //     this.schema.inputs.step5B.thermal_trans_walls.forEach(wall => {
  //       wall.layer_arr_obj.forEach(layerObj => {
  //         if (layerObj.material_n_resistance) {
  //           wallConstructionData.add(layerObj.material_n_resistance.material);
  //         }
  //       });
  //     });
  //     this.schema.wallConstructionAssemblyData = Array.from(wallConstructionData);
  //     console.log('Wall Construction Assembly data', this.schema.wallConstructionAssemblyData);
  //     return wallConstructionData;
  //   },
  // },
  // mounted() {
  //   this.glazingSelection;
  // },
  methods: {
    // downloadWithCSS() {
    //   /** WITH CSS */
    //   domtoimage
    //     .toPng(this.$refs.content)
    //     .then(function(dataUrl) {
    //       var img = new Image();
    //       img.src = dataUrl;
    //       const doc = new jsPDF({
    //         orientation: 'portrait',
    //         // unit: "pt",
    //         format: [900, 1400],
    //       });
    //       doc.addImage(img, 'JPEG', 20, 20);
    //       const date = new Date();
    //       const filename = 'timechart_' + date.getFullYear() + ('0' + (date.getMonth() + 1)).slice(-2) + ('0' + date.getDate()).slice(-2) + ('0' + date.getHours()).slice(-2) + ('0' + date.getMinutes()).slice(-2) + ('0' + date.getSeconds()).slice(-2) + '.pdf';
    //       doc.save(filename);
    //     })
    //     .catch(function(error) {
    //       console.error('oops, something went wrong!', error);
    //     });
    // },
  },
};
</script>

<style lang="scss">
.result__card-wrap {
  margin-top: 76px;
}
// .printBtn {
//   position: absolute;
//   right: 284px;
//   margin: 16px;
//   z-index: 2;
// }
.graphs__card {
  background-color: #fff;
  margin-bottom: 12px;
  .graphs-row1 {
    display: flex;
    justify-content: space-evenly;
  }
  .graphs__card-header {
    background-color: #e1f3f1;
    // padding: 12px 4px 12px 4px;
    .heading {
      color: #0d9b8e;
    }
  }
  .--m2 {
    margin: 8px;
  }
}
.charts-shadow {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border-radius: 4px;
}
.tr-result-card {
  background-color: #fff;
  // padding: 20px;
  border-radius: 4px;
  // height: 100%;
  // width: 100%;
  margin-top: 76px;
  margin-bottom: 44px;
}
.result-card-header {
  padding: 16px 24px;
  background-color: #5a6978;
  color: #fff;
  font-size: 24px;
  // margin: auto;
  text-align: center;
}
.result__card-content-container {
  padding: 20px;
  // display: flex;
  .result__subheader-row {
    background-color: #c4def5;
    padding: 12px 24px;
    color: #318ddd;
    font-size: 20px;
    text-align: left;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    display: flex;

    justify-content: space-between;
    .last-item {
      width: 240px;
    }
  }
}
.result__card-row {
  outline: 1px solid #dedede;

  display: flex;
  justify-content: space-around;
  padding: 6px;
  border-bottom: 1px solid #dedede;
  .result__input-label {
    width: 240px;
  }
  .result__shading--title {
    display: flex;
    flex-direction: column;
    td {
      border-bottom: 1px solid #dedede;
    }
  }
  .result__input-value {
    width: 240px;
  }
  .result__input-multivalue {
    // width: 240px;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}
.result__card-conclusion {
  padding: 20px;
}
.conclusion-header {
  background-color: #c4def5;
  color: #fff;
  font-size: 24px;
  padding: 12px 24px;
  color: #318ddd;
  font-size: 20px;
  text-align: center;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

.conclusion-row {
  display: flex;
  justify-content: space-around;
  padding: 6px;
  border-bottom: 1px solid #dedede;
  outline: 1px solid #dedede;

  .label {
    width: 200px;
  }
  .value {
    width: 30%;
    text-align: center;
    padding: 4px;
    background-color: #c8f0e0;
    color: #2cb17c;
    border-radius: 4px;
  }
  .--invalid {
    background-color: #ffebeb;
    color: #ff6767;
  }
}
</style>
